
export default (theme) => ({
  dashboardItem: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    margin: theme.spacing(1),
    flexGrow: 1,
  },
  eventTemplateGridItem: { padding: theme.spacing(1) },
  catagoryTitle: {
    margin: theme.spacing(1),
    paddingTop: theme.spacing(2),
    display: 'inline-block',
    width: '100%',
  },
  tenantUserSelect: { width: '100%' },
  searchField: {
    margin: theme.spacing(1),
    float: 'right',
  },
  paginationButton: { margin: theme.spacing(1) },
  paginationContainer: {
    float: 'right',
    marginTop: theme.spacing(2),
  },
  alignCenter: { textAlign: 'center' },
});
